import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import RadioGroup from '../radio/radio_group.js';
import CheckboxGroup from '../checkbox/checkbox_group.js';
import TextField from '../text_field/text_field.js';
import { htmlDecode } from '../helpers.js';
import './line_item.css';

var LineItemOptions = function (_Component) {
	_inherits(LineItemOptions, _Component);

	function LineItemOptions() {
		_classCallCheck(this, LineItemOptions);

		return _possibleConstructorReturn(this, (LineItemOptions.__proto__ || Object.getPrototypeOf(LineItemOptions)).call(this));
	}

	_createClass(LineItemOptions, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    shopify_product = _props.shopify_product,
			    select_by = _props.select_by,
			    step_index = _props.step_index,
			    addLineItem = _props.addLineItem,
			    wkSelectedOptions = _props.wkSelectedOptions,
			    selection = _props.selection,
			    maxlength = _props.maxlength;


			return React.createElement(
				'div',
				{ className: 'selection_section' },
				shopify_product.options && shopify_product.options.map(function (option, index) {
					switch (select_by) {
						case 'radio':
							return React.createElement(RadioGroup, {
								key: 'radiogroup-' + index,
								shopify_product_title: selection.title,
								title: selection.title,
								options: selection.options,
								wkSelectedOptions: wkSelectedOptions,
								step_index: step_index,
								itemAction: addLineItem,
								selection_note: selection.selection_note });
						case 'checkbox':
							return React.createElement(CheckboxGroup, {
								key: 'checkboxgroup-' + index,
								shopify_product_title: shopify_product.title,
								title: option.name,
								options: option.values,
								wkSelectedOptions: wkSelectedOptions,
								step_index: step_index,
								itemAction: addLineItem });
						case 'text':
							return React.createElement(TextField, {
								key: 'textfield-' + index,
								title: selection.title,
								note: selection.note,
								required: option.required,
								step_index: index,
								maxlength: maxlength,
								itemAction: addLineItem });
					}
				}),
				selection.selection_note && React.createElement('div', { className: 'selection_note', dangerouslySetInnerHTML: { __html: htmlDecode(selection.selection_note) } })
			);
		}
	}]);

	return LineItemOptions;
}(Component);

export default LineItemOptions;